import tpLogoWordmark from "../../assets/images/tp_logo_wordmark.png";

// Mobile-only wordmark for the auth pages (Sign in / Sign up / Forgot
// password). The desktop wordmark lives in AuthHero's dark panel, which is
// hidden below `md` — so the mobile auth pages carried no branding at all
// (Marin, staging iOS). Rendered absolutely so the centred form layout does
// not reflow; the host column must be `relative`. Horizontally centred and
// sized as a proper eye-catcher (Marin, mobile-sweep follow-up: "im weissen
// wollte ich das logo eigentlich Mittig haben eher etwas präsenter") — the
// centred presentation mirrors the MobileSplash logo treatment. `top-16`
// keeps it clear BELOW the LanguageSelector chip row (chip sits at
// `top-4 right-4`), never behind it.
const AuthMobileLogo = () => (
  <img
    src={tpLogoWordmark}
    alt="TransferPitch"
    className="md:hidden absolute top-16 left-1/2 -translate-x-1/2 h-12 w-auto max-w-[70vw] object-contain"
  />
);

export default AuthMobileLogo;
